// extracted by mini-css-extract-plugin
export default {"wrapperTurkishCepBank":"TurkishCepBank_wrapperTurkishCepBank__N4lRF","checkboxDescriptions":"TurkishCepBank_checkboxDescriptions__20bVq"};